/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking.ts";

function getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingUrl(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams["financialPersonId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/order-tracking` as const,
  };
  return res;
}

/**
 * @description Retorna os logs de pedido (GA_FINANCIAL_ORDER_LOG) do plano com o tipo por extenso, mais recentes primeiro. O legado usava a mesma consulta da parcela. Migrado do legado IndividualPayment/LoadFinancialPersonOrderTrackingGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna o rastreio de pedidos financeiros de um plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/order-tracking}
 */
export async function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingPathParams["financialPersonId"],
  params?: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTracking500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidOrderTrackingUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
